function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.053,
    height: 82.524,
    viewBox: "0 0 104.053 82.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46954",
    d: "M100.465 135.49H3.588A3.588 3.588 0 0 1 0 131.9V56.554a3.588 3.588 0 0 1 3.588-3.588h96.877a3.588 3.588 0 0 1 3.588 3.588V131.9a3.588 3.588 0 0 1-3.588 3.59z",
    style: {
      fill: "#fff"
    },
    transform: "translate(0 -52.966)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46955",
    d: "M0 63.73h104.053v-7.176a3.588 3.588 0 0 0-3.588-3.588H3.588A3.588 3.588 0 0 0 0 56.554z",
    style: {
      fill: "#c3e678"
    },
    transform: "translate(0 -52.966)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14486"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46956",
    d: "M33.8 74.208H19.449a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794H33.8a1.794 1.794 0 0 1 1.8 1.794 1.8 1.8 0 0 1-1.8 1.794z",
    transform: "translate(-14.067 -67.032)",
    style: {
      fill: "#ebf5aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46957",
    d: "M128.968 74.208h-3.588a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h3.588a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-98.47 -67.032)",
    style: {
      fill: "#ebf5aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46958",
    d: "M464.416 74.208h-3.588a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h3.588a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-365.745 -67.032)",
    style: {
      fill: "#ebf5aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46959",
    d: "M411.451 74.208h-3.588a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h3.588a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-323.544 -67.032)",
    style: {
      fill: "#ebf5aa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12055",
    transform: "translate(0 10.764)",
    style: {
      fill: "#d7deed"
    },
    d: "M0 0h104.053v10.764H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14487",
    style: {
      opacity: 0.97
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46960",
    d: "M24.831 127.173h-5.382a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h5.382a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-14.067 -109.233)",
    style: {
      fill: "#afb9d2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46961",
    d: "M86.624 127.173h-5.382a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h5.382a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-63.302 -109.233)",
    style: {
      fill: "#ffd782"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14488"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46962",
    d: "M144.829 127.173h-1.794a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h1.794a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-112.537 -109.233)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46963",
    d: "M188.966 127.173h-1.794a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h1.794a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-147.704 -109.233)",
    style: {
      fill: "#b4e1fa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46964",
    d: "M236.693 127.173h-5.382a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h5.382a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-182.873 -109.233)",
    style: {
      fill: "#c7cfe2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14489"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46965",
    d: "M296.692 127.173H293.1a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h3.588a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.79 1.794z",
    transform: "translate(-232.108 -109.233)",
    style: {
      fill: "#eff2fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46966",
    d: "M349.658 127.173h-3.588a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h3.588a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-274.31 -109.233)",
    style: {
      fill: "#eff2fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14490"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46967",
    d: "M404.417 127.173h-5.382a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h5.382a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-316.51 -109.233)",
    style: {
      fill: "#c7cfe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46968",
    d: "M464.416 127.173h-3.588a1.794 1.794 0 0 1-1.794-1.794 1.794 1.794 0 0 1 1.794-1.794h3.588a1.794 1.794 0 0 1 1.794 1.794 1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-365.745 -109.233)",
    style: {
      fill: "#c7cfe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12056",
    transform: "translate(0 21.528)",
    style: {
      fill: "#c7cfe2"
    },
    d: "M0 0h104.053v3.588H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14491"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46969",
    d: "M238.487 199.588h-7.176a1.794 1.794 0 0 1-1.794-1.794V196a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-182.873 -165.502)",
    style: {
      fill: "#8f96ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46970",
    d: "M97.246 199.588H90.07a1.794 1.794 0 0 1-1.794-1.794V196a1.794 1.794 0 0 1 1.794-1.794h7.176A1.794 1.794 0 0 1 99.04 196v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-70.336 -165.502)",
    style: {
      fill: "#8f96ac"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46971",
    d: "M26.625 199.588h-7.176a1.794 1.794 0 0 1-1.794-1.794V196a1.794 1.794 0 0 1 1.794-1.794h7.176A1.794 1.794 0 0 1 28.419 196v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-14.067 -165.502)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14492"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46972",
    d: "M167.866 199.588h-7.176a1.794 1.794 0 0 1-1.794-1.794V196a1.794 1.794 0 0 1 1.794-1.794h7.176A1.794 1.794 0 0 1 169.66 196v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-126.604 -165.502)",
    style: {
      fill: "#8f96ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46973",
    d: "M379.729 199.588h-7.176a1.794 1.794 0 0 1-1.794-1.794V196a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-295.41 -165.502)",
    style: {
      fill: "#8f96ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46974",
    d: "M309.108 199.588h-7.176a1.794 1.794 0 0 1-1.794-1.794V196a1.794 1.794 0 0 1 1.794-1.794h7.176A1.794 1.794 0 0 1 310.9 196v1.794a1.794 1.794 0 0 1-1.792 1.794z",
    transform: "translate(-239.142 -165.502)",
    style: {
      fill: "#8f96ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46975",
    d: "M450.349 199.588h-7.176a1.794 1.794 0 0 1-1.794-1.794V196a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-351.678 -165.502)",
    style: {
      fill: "#8f96ac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14493"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46976",
    d: "M238.487 243.726h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-182.873 -200.67)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46977",
    d: "M97.246 243.726H90.07a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-70.336 -200.67)",
    style: {
      fill: "#d7deed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46978",
    d: "M26.625 243.726h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-14.067 -200.67)",
    style: {
      fill: "#c3e678"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14494"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46979",
    d: "M167.866 243.726h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-126.604 -200.67)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46980",
    d: "M379.729 243.726h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-295.41 -200.67)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46981",
    d: "M309.108 243.726h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-239.142 -200.67)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46982",
    d: "M450.349 243.726h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-351.679 -200.67)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46983",
    d: "M238.487 287.864h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-182.873 -235.838)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46984",
    d: "M97.246 287.864H90.07a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-70.336 -235.838)",
    style: {
      fill: "#d7deed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46985",
    d: "M26.625 287.864h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-14.067 -235.838)",
    style: {
      fill: "#c3e678"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14495"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46986",
    d: "M167.866 287.864h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-126.604 -235.838)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46987",
    d: "M379.729 287.864h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-295.41 -235.838)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46988",
    d: "M309.108 287.864h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-239.142 -235.838)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46989",
    d: "M450.349 287.864h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-351.679 -235.838)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46990",
    d: "M238.487 332h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-182.873 -271.005)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46991",
    d: "M97.246 332H90.07a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794A1.794 1.794 0 0 1 97.246 332z",
    transform: "translate(-70.336 -271.005)",
    style: {
      fill: "#d7deed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46992",
    d: "M26.625 332h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794A1.794 1.794 0 0 1 26.625 332z",
    transform: "translate(-14.067 -271.005)",
    style: {
      fill: "#c3e678"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14496"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46993",
    d: "M167.866 332h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-126.604 -271.005)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46994",
    d: "M379.729 332h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-295.41 -271.005)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46995",
    d: "M309.108 332h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-239.142 -271.005)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46996",
    d: "M450.349 332h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-351.679 -271.005)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46997",
    d: "M238.487 376.139h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-182.873 -306.173)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46998",
    d: "M97.246 376.139H90.07a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-70.336 -306.173)",
    style: {
      fill: "#d7deed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46999",
    d: "M26.625 376.139h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-14.067 -306.173)",
    style: {
      fill: "#c3e678"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14497"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47000",
    d: "M167.866 376.139h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-126.604 -306.173)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47001",
    d: "M379.729 376.139h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-295.41 -306.173)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47002",
    d: "M309.108 376.139h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-239.142 -306.173)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47003",
    d: "M450.349 376.139h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-351.679 -306.173)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47004",
    d: "M238.487 420.277h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-182.873 -341.341)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47005",
    d: "M97.246 420.277H90.07a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.789h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.789z",
    transform: "translate(-70.336 -341.341)",
    style: {
      fill: "#d7deed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47006",
    d: "M26.625 420.277h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-14.067 -341.341)",
    style: {
      fill: "#c3e678"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14498"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47007",
    d: "M167.866 420.277h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-126.604 -341.341)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47008",
    d: "M379.729 420.277h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-295.41 -341.341)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47009",
    d: "M309.108 420.277h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-239.142 -341.341)",
    style: {
      fill: "#d7deed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47010",
    d: "M450.349 420.277h-7.176a1.794 1.794 0 0 1-1.794-1.794v-1.794a1.794 1.794 0 0 1 1.794-1.794h7.176a1.794 1.794 0 0 1 1.794 1.794v1.794a1.794 1.794 0 0 1-1.794 1.794z",
    transform: "translate(-351.678 -341.341)",
    style: {
      fill: "#d7deed"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.c8745ca8c02706947aff64268a3c683b.svg";
export { ForwardRef as ReactComponent };